const resources = {
    searchTitle: 'Rechercher des photos et des vidéos',
    explore: 'Découvrir',
    uploadToGallery: '+ Télécharger dans la galerie',
    cancel: 'Cancel',
    resultsFor: ' results for ',
    clearAll: 'Clear all'
};

module.exports = function getResource(label) {
    return resources[label];
};
